import { APIsResponse, ChangesResponse } from './model';

const getAPIs = async (): Promise<APIsResponse | null> => {
    const r = await fetch(`/v2alpha/api/metadata`, { method: 'GET' });
    if (!r.ok) {
        throw await r.json();
        return null;
    }
    return await r.json();
};

const getAPI = async (identifier: string, apiVersion: string): Promise<object | undefined> => {
    const backendRoute = apiVersion === '' ? `/oas/${identifier}` : `/oas/${identifier}/version/${apiVersion}`;
    const r = await fetch(backendRoute, { method: 'GET' });

    if (!r.ok) {
        throw await r.json();
    }

    return await r.json();
};

const getChanges = async (): Promise<ChangesResponse | null> => {
    const r = await fetch(`/v2alpha/changes`, { method: 'GET' });
    if (!r.ok) {
        throw await r.json();
        return null;
    }
    return await r.json();
};

export const Webservice = { getAPIs, getAPI, getChanges };
